import useIsMobile from "../../../../hooks/useIsMobile";
import { getCookie } from "../../../../helpers/localStorage";
import { Role } from "../../../../constants/defaultKeys";

const useIsNurseMobile = () => {
  const isMobile = useIsMobile();
  const isNurseMobile =
    isMobile && getCookie(Role)?.toLowerCase()?.includes("nurse");

  return isNurseMobile;
};

export default useIsNurseMobile;
